/**
 * @generated SignedSource<<66e8989bc7d8582585e2ea5fc72acc50>>
 * @relayHash 222f731dee9418977013fbdf3d462348
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 99bd5148d26f20b3917ab14924be203a79e70ff7e1d69ef2c135c05f75a20c48

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiFieldsPageQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type uiFieldsPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"fieldsTable_projectFields" | "pageHeader_projectFields_Header">;
};
export type uiFieldsPageQuery = {
  response: uiFieldsPageQuery$data;
  variables: uiFieldsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "projectKey",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiFieldsPageQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "fieldsTable_projectFields"
      },
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "pageHeader_projectFields_Header"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiFieldsPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v2/*: any*/),
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "issueTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "concreteType": "JiraProjectWithIssueTypeIds",
                "kind": "LinkedField",
                "name": "projectWithVisibleIssueTypeIds",
                "plural": false,
                "selections": [
                  {
                    "args": (v8/*: any*/),
                    "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                    "kind": "LinkedField",
                    "name": "fieldAssociationWithIssueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                  },
                                  (v7/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "scope"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "typeKey"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "typeName"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "description"
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraIssueTypeConnection",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v5/*: any*/),
                                          (v7/*: any*/),
                                          (v6/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v7/*: any*/),
                              {
                                "concreteType": "JiraFieldOperation",
                                "kind": "LinkedField",
                                "name": "fieldOperation",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canRemove"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          }
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ],
                    "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                  },
                  {
                    "args": (v8/*: any*/),
                    "handle": "connection",
                    "key": "fieldsTable_fieldAssociationWithIssueTypes",
                    "kind": "LinkedHandle",
                    "name": "fieldAssociationWithIssueTypes"
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "99bd5148d26f20b3917ab14924be203a79e70ff7e1d69ef2c135c05f75a20c48",
    "metadata": {},
    "name": "uiFieldsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "befb21bfee3eccfd8224eedab696066f";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
